import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import CommonModal from '../../Components/CommonModal';
import { send_invitation_to_vendor } from '../../services';
import '../../styles/TpcrmPortal.scss';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const DEFAULT_VALUES = { email: '' };

// Config-driven field (CommonModal's `fields=`/`defaultValues=`/`onSubmit=`
// mode). Contact Number is handled separately below via `react-phone-input-2`
// — the same combined flag-picker + formatted-number widget already used by
// Signup.js and the old dashboard's InviteVendor.js — instead of splitting it
// into a Country Code `select` + plain `tel` field. That split was tried
// first to fit CommonModal's `fields=` mode (no field type matches
// PhoneInput's combined widget), but it re-implemented country-code
// selection with a bespoke CommonDropdown that has no smart open-direction
// logic, causing it to render off-screen/invisible once squeezed into a
// narrow column. `react-phone-input-2` is the app's actual established
// pattern for this exact input — reused as-is instead.
const FIELDS = [
    {
        name: 'email', label: 'Work Email Address', type: 'email', required: 'Email is required.',
        placeholder: 'name@company.com',
        pattern: { value: EMAIL_REGEX, message: 'Enter a valid email.' },
    },
];

function InviteVendorModal({ show, id, onHide, onSuccess }) {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');

    const handleHide = () => {
        setError('');
        setPhoneNumber('');
        onHide?.();
    };

    const handleFormSubmit = async (data) => {
        setLoading(true);
        setError('');
        try {
            const payload = { relation_id: id, email: data.email };
            // Phone is optional — only send it if the vendor actually entered
            // digits beyond whatever country code PhoneInput defaults to.
            if (phoneNumber && phoneNumber.replace(/\D/g, '').length > 0) {
                payload.phone_number = phoneNumber;
            }
            const response = await send_invitation_to_vendor(payload);
            const message = response?.statusCode?.response_data?.message;
            if (message) {
                onSuccess?.();
            } else {
                setError(response?.statusCode?.error?.message || 'Unable to send the invitation.');
            }
        } catch (err) {
            console.error('Failed to invite vendor:', err);
            setError('Unable to send the invitation.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <CommonModal
            show={show}
            onHide={handleHide}
            title="Invite Vendor"
            subtitle="Send a questionnaire invitation to this vendor's contact."
            error={error}
            fields={FIELDS}
            defaultValues={DEFAULT_VALUES}
            onSubmit={handleFormSubmit}
            buttons={[
                { text: 'Cancel', variant: 'secondary', onClick: handleHide, disabled: loading },
                { text: 'Invite Vendor', variant: 'primary', type: 'submit', loading, loadingText: 'Sending…' },
            ]}
        >
            <div className="cmn-modal-field" style={{ marginTop: 16 }}>
                <label className="cmn-modal-label">Contact Number (recommended)</label>
                <PhoneInput
                    country="in"
                    value={phoneNumber}
                    onChange={setPhoneNumber}
                    inputProps={{ name: 'phone_number' }}
                    containerClass="tpcrm-phone-input"
                    inputClass="tpcrm-phone-field"
                    buttonClass="tpcrm-phone-button"
                    dropdownClass="tpcrm-phone-dropdown"
                    searchClass="tpcrm-phone-search"
                    enableSearch
                />
            </div>
        </CommonModal>
    );
}

export default InviteVendorModal;
